import { createContext, type ReactNode, useContext } from 'react'
import { createSupabaseEventService, type EventService } from './eventService'

const defaultService = createSupabaseEventService()
const EventServiceContext = createContext<EventService>(defaultService)

export function EventServiceProvider({ children, service = defaultService }: { children: ReactNode; service?: EventService }) {
  return <EventServiceContext.Provider value={service}>{children}</EventServiceContext.Provider>
}

export function useEventService() {
  return useContext(EventServiceContext)
}
